import React from "react";

// Renders a citation block: source, verse, the line itself (often Sanskrit
// transliteration), and a translation. Anchors a card to the scripture.
export default function ScripturalAnchor({ anchor, compact = false }) {
  if (!anchor) return null;
  const { source, verse, line, translation } = anchor;
  return (
    <div className={`anchor-block ${compact ? "" : "my-4"}`}>
      <div className="font-body text-[0.65rem] tracking-widest2 uppercase text-dharma-gold-deep">
        {source}
        {verse && <span className="text-ink-mute"> · {verse}</span>}
      </div>
      {line && (
        <div className="font-serif italic text-ink leading-snug mt-1.5 text-base md:text-lg">
          {line}
        </div>
      )}
      {translation && (
        <div className="font-serif text-ink-soft leading-snug mt-1 text-sm md:text-base">
          {translation}
        </div>
      )}
    </div>
  );
}
